<template>
  <div>
    <v-autocomplete height="48px" class="mt-1 rounded-lg" filled dense rounded clearable append-icon="search" hide-details
      :placeholder="'Kontakte suchen'" @change="selectBbr()" :items="selectBundesbruder"
      v-model="bundesbruder"></v-autocomplete>
    <div v-if="bundesbruder">
      <dialogKontakt :visible.sync="showBbr" :bbr="bbr" @close="showBbr = false"></dialogKontakt>
    </div>
    <!-- <v-btn icon class="hidden-sm-and-down" v-on="on"><v-icon>search</v-icon></v-btn> -->
  </div>
</template>

<script>
export default {
  props: ['dark'],
  data () {
    return {
      bundesbruder: '',
      bbr: [],
      showBbr: false
    }
  },
  computed: {
    selectBundesbruder () {
      const items = this.$store.getters['bbrbbr/nurBbrbbr']
      return items.map(item => ({
        value: item.id,
        text: `${item.nachname}, ${item.vorname}${item.vulgo ? ` (${item.vulgo})` : ''}`
      }))
    }
  },
  methods: {
    selectBbr () {
      this.bbr = this.$store.getters['bbrbbr/bbr'](this.bundesbruder)
      this.showBbr = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// bundesbruderSucheShort.vue?50a0f33a